import { render, staticRenderFns } from "./SwitchStageStatus.vue?vue&type=template&id=e2946752&"
import script from "./SwitchStageStatus.vue?vue&type=script&lang=js&"
export * from "./SwitchStageStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports